import { render, staticRenderFns } from "./formPemenuhan13.vue?vue&type=template&id=1fbedb80&"
import script from "./formPemenuhan13.vue?vue&type=script&lang=js&"
export * from "./formPemenuhan13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports